export default function VPNServices() {
  const services = [
    {
      icon: 'ri-play-circle-line',
      title: 'One-Click Connection',
      description: 'Connect to the fastest server instantly with a single click. No complex setup required.'
    },
    {
      icon: 'ri-global-line',
      title: 'Server Selection',
      description: 'Choose from hundreds of servers across 60+ countries for optimal speed and access.'
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Kill Switch Protection',
      description: 'Automatically blocks internet traffic if VPN connection drops, preventing data leaks.'
    },
    {
      icon: 'ri-git-branch-line',
      title: 'Split Tunneling',
      description: 'Route specific apps through VPN while others use regular connection for flexibility.'
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'DNS Leak Protection',
      description: 'Prevents DNS requests from leaking outside the VPN tunnel for complete privacy.'
    }
  ];

  return (
    <section id="vpn-services" className="py-24 bg-[#0F1419] relative overflow-hidden">
      <div className="absolute bottom-0 right-0 text-[#1a2332] text-[180px] font-bold opacity-5 select-none">
        VIAPREC
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white">
            Complete VPN Solution
          </h2>
          <div className="w-16 h-1 bg-[#00D4FF] mx-auto mt-6"></div>
        </div>

        <div className="bg-white/5 backdrop-blur-md rounded-3xl border border-[#00D4FF]/30 p-8 md:p-12">
          <div className="grid md:grid-cols-5 gap-12 items-center">
            <div className="md:col-span-2">
              <div className="relative w-full h-[400px] rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/9b5b4397bd16aaedc220369a0d2efb86.jpg"
                  alt="VPN Dashboard Interface"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="md:col-span-3 space-y-8">
              {services.map((service, index) => (
                <div key={index} className="flex items-start space-x-4 group">
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-[#00D4FF] text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-white text-xl font-semibold mb-2 group-hover:text-[#00D4FF] transition-colors duration-300">
                      {service.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
